sendSituationInvoice = function ($btn, invoiceId, situationId, callback) {
    let $loading = $('#loadingDiv').hide();
    $(document)
        .ajaxStart(function () {
            $loading.show();
            if ($btn != null) $btn.attr('disabled', 'disabled');
        })
        .ajaxStop(function () {
            $loading.hide();
            if ($btn != null) $btn.removeAttr('disabled');
        });

    $.ajax('/app/admin/invoice/situation/' + invoiceId + '/' + situationId, {
        mehtod: 'GET',
        success: callback,
        error: function () {
            alert('Operação naõ realizada, fale com suporte.');
        }
    });
};

successDefault = function () {
    alert('Operação realizada com sucesso.');
    document.location.reload(true);
};

paymentDown = function (id) {
    event.preventDefault();
    if (confirm("Deseja realizar a baixa dessa fatura?")) {
        sendSituationInvoice($(this), id, 2, successDefault);
    }
};

paymentCanceled = function (id) {
    event.preventDefault();
    if (confirm("Deseja realizar o cancelamento dessa fatura?")) {
        sendSituationInvoice($(this), id, 3, successDefault);
    }
};

$('input#all').on('click', function () {
    let element = $(this);
    let cks = element.attr('data-toogle');
    $(cks).attr('checked', element.is(':checked'));
});

$('button#paymentDown').on('click', function () {
    $btn = $(this);
    if (confirm("Confirma esta operação?")) {
        $btn.attr('disabled', 'disabled');
        $inputs = $btn.closest('table').find('tbody').find('td input[type="checkbox"]:checked');
        $inputs.each(function (index, element) {
            sendSituationInvoice(null, element.value, 2, function () {
                
            });
        });

        alert('Operação realizada com sucesso.');
        document.location.reload(true);
    }
    $btn.removeAttr('disabled');
});

$('button#paymentCanceled').on('click', function () {
    $btn = $(this);
    if (confirm("Confirma esta operação?")) {
        $btn.attr('disabled', 'disabled');
        $inputs = $btn.closest('table').find('tbody').find('td input[type="checkbox"]:checked');
        $inputs.each(function (index, element) {
            sendSituationInvoice(null, element.value, 3, function () {

            });
        });

        alert('Operação realizada com sucesso.');
        document.location.reload(true);
    }
    $btn.removeAttr('disabled');
});




// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-paymentr.js